{
  "title": "Transactions",
  "table": {
    "searchPlaceholder": "Search Transactions",
    "headers": {
      "date": "Date",
      "id": "ID & type",
      "from": "From",
      "to": "To",
      "paymentDetail": "Payment Detail",
      "amount": "Amount",
      "balance": "Balance",
      "action": "Action"
    },
    "rows": {
      "autoAllocation": "Auto Allocation",
      "bankRejected": "Bank Rejected",
      "charges": "Charges",
      "clientSpotTrade": "Client Spot Trade",
      "complianceApproved": "Compliance Approved",
      "complianceApprovedCorrection": "Compliance Approved Correction",
      "complianceApprovedTransfer": "Compliance Approved Transfer",
      "complianceRejected": "Compliance Rejected",
      "complianceRejectedCorrection": "Compliance Rejected Correction",
      "complianceRejectedTransfer": "Compliance Rejected Transfer",
      "correction": "Correction",
      "counterpartyFx": "Counterparty FX",
      "creditLinePreFunding": "Credit Line Pre-Funding",
      "creditLineRePayment": "Credit Line Re-Payment",
      "creditNoteTransfer": "Credit-Note Transfer",
      "fx": "FX",
      "fxTransfer": "FX Transfer",
      "goodwill": "Goodwill",
      "headerTransfer": "Header Transfer",
      "inboundCorrection": "Inbound Correction",
      "inboundInterest": "Inbound Interest",
      "inboundTransfer": "Inbound Transfer",
      "inboundTransferHeader": "Inbound Transfer Header",
      "inboundTreasury": "Inbound Treasury",
      "interest": "Interest",
      "internalAccountTransfer": "Internal Account Transfer",
      "internalPayment": "Internal Payment",
      "invoiceReversal": "Invoice Reversal",
      "invoiceTransfer": "Invoice Transfer",
      "legacyInstruction": "Legacy Instruction",
      "outboundPaymentCleared": "Outbound Payment Cleared",
      "outboundPaymentRejected": "Outbound Payment Rejected",
      "payment": "Payment",
      "beneficiaryDeductFee": "Beneficiary Deduct",
      "preFunding": "Pre-Funding",
      "receipt": "Inbound Payment",
      "reset": "Reset",
      "returned": "Returned",
      "returnedToBank": "Returned To Bank",
      "rmTransfer": "RM Transfer",
      "settlementsSweep": "Settlements Sweep",
      "sweep": "Sweep",
      "transfer": "Internal Transfer",
      "treasury": "Treasury Transfer",
      "treasuryCloseOut": "Treasury Close-Out"
    },
    "dataError": "Access to view transactions for the selected entities is restricted for the current user",
    "currencyAccountsDataError": "Access to view currency accounts for the selected entities is restricted for the current user",
    "dropdown": {
      "action": "Action",
      "view": "View details",
      "download": "Download"
    },
    "accountCurrency": "{{currencyCode}}"
  },
  "drawer": {
    "fxTransferTitle": "FX Transfer confirmation",
    "transferTitle": "Transfer confirmation",
    "paymentTitle": "Payment confirmation",
    "beneDeductTitle": "Beneficiary Deduct",
    "inboundPaymentTitle": "Inbound Payment",
    "inboundPaymentDetailsTitle": "Payment Details",
    "remitterDetailsTitle": "Remitter Details",
    "dataError": "There was an error retrieving your transaction data",
    "dataLoading": "Retrieving your transaction data",
    "chipStatus": {
      "completed": "Completed"
    },
    "downloadButton": "Download confirmation",
    "paymentDetails": {
      "beneficiary": {
        "name": "Beneficiary Name",
        "bank": "Beneficiary Bank",
        "swift": "Swift/BIC",
        "iban": "IBAN",
        "accountNumber": "Account Number",
        "nationalBankCode": "National Bank Code",
        "correspondentAccount": "Correspondent account",
        "correspondentSwift": "Correspondent SWIFT",
        "furtherToAccount": "Further to account",
        "furtherToSwift": "Further to SWIFT",
        "type": "Individual/Company"
      },
      "payment": {
        "reference": "Payment Reference",
        "amount": "Payment Amount",
        "date": "Payment Date",
        "currency": "Currency",
        "fixedSide": "Fixed Side",
        "purposeOfPayment": "Purpose of payment",
        "debitingAccountDetails": "Debiting account details",
        "debitingAccountCurrency": "Debiting account currency",
        "fundingAccountDetails": "Funding account details",
        "fundingAccountCurrency": "Funding account currency"
      },
      "beneDeductFee": {
        "details": "Details",
        "linkedPayment": "Linked Payment",
        "date": "Date",
        "id": "ID",
        "type": "Type",
        "reference": "Reference",
        "amount": "Amount",
        "paymentId": "Payment ID",
        "beneficiary": "Beneficiary",
        "instructedAmount": "Instructed amount",
        "beneficiaryReceives": "Beneficiary receives"
      },
      "inboundPayment": {
        "reference": "Reference",
        "amount": "Amount",
        "date": "Date",
        "type": "Type",
        "name": "Name",
        "entityAddress": "Entity Address",
        "iban": "IBAN",
        "nationalBankCode": "National Bank Code",
        "swift": "SWIFT",
        "additionalInfo": "Additional Information"
      },
      "timeline": {
        "uploadedBy": "Uploaded by",
        "approvedBy": "Approved by",
        "completedDate": "Completed Date"
      }
    },
    "internalTransferDetails": {
      "transfer": {
        "reference": "Reference",
        "date": "Transfer date"
      },
      "debitCredit": {
        "debitingAccount": "Debiting account",
        "debitingAmount": "Debiting amount",
        "fxRate": "FX Rate",
        "creditingAccount": "Crediting account",
        "creditingAmount": "Crediting amount"
      }
    },
    "fxTransferDetails": {
      "trade": {
        "id": "Trade ID",
        "reference": "Reference",
        "date": "Trade date"
      },
      "debitCredit": {
        "debitingAccount": "Debiting account",
        "debitingAmount": "Debiting amount",
        "fxRate": "FX Rate",
        "creditingAccount": "Crediting account",
        "creditingAmount": "Crediting amount"
      }
    }
  },
  "download": {
    "genericPDFError": "This transaction summary is not available. Please contact customer support.",
    "downloadLink": "There was an issue getting the confirmation download link: {{error}}.",
    "requestTimedOut": "request timed out"
  },
  "searchCAPlaceholder": "Search for a currency account or entity",
  "account": "Account"
}
